import { css } from 'styled-components';

export const TableSansTitleStyle = css`
    /* Hiding title which is being co-opted to act as the table's <caption>.
    <caption> provides a11y info, but ant-d doesn't currently support it so this is a work-around.*/
    .ant-table-title {
        padding: 0;
    }
`;
